import React from "react";
import "./detailFour.scss";
import jtR from "../../assets/jt-r.png"
import part1Img from "../../assets/productions/insightEpilepsy-part-1.png"
import contentLImg from "../../assets/productions/content-l-img.png"
import contentRImg from "../../assets/productions/content-r-img.png"
import row1Img1 from "../../assets/productions/row-1-img1.png"
import row1Img2 from "../../assets/productions/row-1-img2.png"
import row2Img1 from "../../assets/productions/row-2-img1.png"
import row2Img2 from "../../assets/productions/row-2-img2.png"
import part3Img1 from "../../assets/productions/part-3-img1.png"
import part3Img2 from "../../assets/productions/part-3-img2.png"
import part3Img3 from "../../assets/productions/part-3-img3.png"
import part3Img4 from "../../assets/productions/part-3-img4.png"
import OSS_URL from "../../constants/ossUrl";


class DetailFour extends React.Component {
    render() {
        return <div className="detail-4">
            <h3 className="detail-4-title">癫痫病灶精准定位是国际医疗界难题</h3>
            <div className="part-1">
                <span className="bg-line left"></span>
                <span className="bg-line right"></span>
                <img src={part1Img} className="part-1-img" />
                <div className="content-l">
                    <img src={contentLImg} className="content-l-img" />
                    <p className="content-l-txt">
                        癫痫是第二大神经性疾病， 大脑神经元异常放电引发癫痫发作。
                    </p>
                </div>
                <div className="content-r">
                    <p className="content-l-txt">
                        大量癫痫患者的治疗需要依靠精准定位致痫灶，进而进行神经调控或手术干预。
                    </p>
                    <img src={contentRImg} className="content-l-img" />
                </div>
            </div>
            <div className="part-2">
                <div className="part-2-title">
                    <span className="bg-line left"></span>
                    <h2>
                        <p>InsightEpilepsy<sup>TM</sup>系统</p>
                        <p>基于脑磁图实现癫痫致痫灶无创精准定位</p>
                    </h2>
                    <span className="bg-line right"></span>
                </div>
                <div className="part-2-content">
                    <div className="row-1">
                        <div className="row-1-left">
                            <h3>脑磁图</h3>
                            <img src={row1Img1} />
                        </div>
                        <div className="row-1-right">
                            <h3>InsightEpilepsy<sup>TM</sup>系统</h3>
                            <img src={row1Img2}/>
                        </div>
                    </div>
                    <div className="row-split">
                        <span className="bg-line left"></span>
                        <img src={jtR} className="split-arrow" />
                        <span className="bg-line right"></span>
                    </div>
                    <div className="row-2">
                        <div className="row-1-left">
                            <img src={row2Img1} />
                            <div className="img-desc">
                                <p>记录癫痫患者</p>
                                <p>致痫灶神经元异常放电</p>
                            </div>
                        </div>
                        <div className="row-1-right">
                            <img src={row2Img2}/>
                            <div className="img-desc">
                                <p>实现癫痫患者</p>
                                <p>致痫灶无创精准定位</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="part-3">
                <div className="part-2-title">
                    <span className="bg-line left"></span>
                    <h2>
                        <p>InsightEpilepsy<sup>TM</sup>系统为临床医生实施</p>
                        <p>安全可靠的癫痫致痫灶无创精准定位</p>
                        <p>提供创新型医疗器械</p>
                    </h2>
                    <span className="bg-line right"></span>
                </div>
                <div className="part-3-content">
                    <div className="row">
                        <div className="col" style={{ marginRight: "10.6333rem" }}>
                            <img src={part3Img1} />
                            <div className="col-title">
                                <span className="bg-circle"></span>
                                <h3>改进深部脑刺激治疗</h3>
                            </div>
                            <div className="col-desc">
                                <p>无创精准定位致痫灶的空间位置</p>
                                <p>辅助深部脑刺激（DBS）电极植入</p>
                                <p>提高DBS植入准确率</p>
                                <p>缩短治疗周期，减轻患者痛苦</p>
                            </div>
                        </div>
                        <div className="col">
                            <img src={part3Img2} />
                            <div className="col-title">
                                <span className="bg-circle"></span>
                                <h3>辅助手术术前规划</h3>
                            </div>
                            <div className="col-desc">
                                <p>无创精准定位致痫灶的空间位置</p>
                                <p>减少术前颅内电极（sEEG）插入</p>
                                <p>辅助致痫灶切除手术术前规划</p>
                                <p>提高患者愈后效果</p>
                            </div>
                        </div>
                        <div className="col" style={{ marginRight: "10.6333rem" }}>
                            <img src={part3Img3} />
                            <div className="col-title">
                                <span className="bg-circle"></span>
                                <h3>引导反应式刺激电极植入</h3>
                            </div>
                            <div className="col-desc">
                                <p>无创精准定位致痫灶的空间位置</p>
                                <p>为反应式神经刺激电极（RNS）植入</p>
                                <p>提供定位参考</p>
                                <p>为药物难治型癫痫提供治疗新方案</p>
                            </div>
                        </div>
                        <div className="col">
                            <img src={part3Img4} />
                            <div className="col-title">
                                <span className="bg-circle"></span>
                                <h3>提供术后评估客观依据</h3>
                            </div>
                            <div className="col-desc">
                                <p>无创精准定位致痫灶的空间位置</p>
                                <p>为多种癫痫手术治疗方案</p>
                                <p>提供术后评估客观依据</p>
                                <p>服务于医疗机构降本增效</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}
export default DetailFour;